import { Close } from "@mui/icons-material";
import { Box, Card, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

interface StyledCardProps {
    fixed?: boolean;
}

const StyledCardBase = styled(Card, {
    shouldForwardProp: (prop) => prop !== "fixed",
})<StyledCardProps>(({ theme, fixed }) => ({
    width: "90vw",
    height: "200px",
    boxShadow: `0 0 10px -2px ${
        theme.palette.mode === "light"
            ? theme.palette.grey[500]
            : theme.palette.grey[800]
    }`,
    backgroundColor: theme.palette.background.default,
    ...(fixed
        ? {
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 101,
          }
        : {
              position: "relative",
          }),
}));

const StyledCloseBtn = styled(IconButton)(({ theme }) => ({
    position: "absolute",
    right: 8,
    top: 8,
    color: theme.palette.grey[500],
}));

const StyledDialogContent = styled(Box)({
    marginTop: "45px",
    padding: "15px",
});

interface AlertDialogProps {
    onClose: () => void;
    fixed?: boolean;
    children?: React.ReactNode;
}

export const AlertDialog = (props: AlertDialogProps) => {
    const { onClose, fixed, children } = props;
    return (
        <StyledCardBase fixed={fixed} data-testid="alert-dialog">
            <StyledCloseBtn onClick={onClose}>
                <Close />
            </StyledCloseBtn>
            <StyledDialogContent>{children}</StyledDialogContent>
        </StyledCardBase>
    );
};
